var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextBold = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4.5 3.5h4.25a2.5 2.5 0 0 1 2.5 2.5 2.53 2.53 0 0 1-1.585 2.335 2.53 2.53 0 0 1 1.585 2.336 2.5 2.5 0 0 1-2.5 2.5H4.5V3.5ZM4.5 8.335h4.25"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextBold);
export default ForwardRef;